import { Button } from '../../../components/ui/Button'
import React from 'react'

interface InitialPaymentSuccessProps {
  onFinalize?: () => void
}

const InitialPaymentSuccess: React.FC<InitialPaymentSuccessProps> = ({
  onFinalize,
}) => {
  return (
    <div className="min-h-full flex items-center justify-center">
      <div className="max-w-3xl w-full bg-transparent rounded-xl p-10 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 leading-tight">
          Hemos registrado tu método de pago
        </h1>

        <div className="mb-10">
          <p className="text-lg text-gray-600 leading-relaxed mb-8 text-center">
            Ahora, realiza el depósito o la transferencia por el monto indicado
            y guarda tu comprobante. Una vez que verifiquemos el pago, te
            contactaremos para agendar la firma presencial del contrato y
            finalizar el proceso de arrendamiento.
          </p>

          <div className="flex items-start gap-3 p text-left">
            <span className="text-xl mt-0.5">📌</span>
            <span className="text-gray-600 leading-relaxed">
              Importante: No olvides conservar tu comprobante de pago. Podrás
              subirlo más adelante o presentarlo durante la firma.
            </span>
          </div>
        </div>

        <Button
          variant="secondary"
          onClick={onFinalize}
          className="px-8 py-3 min-w-[260px]"
        >
          Finalizar
        </Button>
      </div>
    </div>
  )
}

export default InitialPaymentSuccess
